import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupUnion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBooleanGroupUnion"><Path d="M8.75 2C8.33579 2 8 2.33579 8 2.75V8H2.75C2.33579 8 2 8.33579 2 8.75V21.25C2 21.6642 2.33579 22 2.75 22H15.25C15.6642 22 16 21.6642 16 21.25V16H21.25C21.6642 16 22 15.6642 22 15.25V2.75C22 2.33579 21.6642 2 21.25 2H8.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupUnion;
